export default __webpack_public_path__ + "static/media/carto-white.1c472753.PNG";